import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { GlobalStyle } from "./styled";
export const InjectGlobalStyles = ({ children }) => {
    return (_jsxs(_Fragment, { children: [_jsx(GlobalStyle, {}), children] }));
};
